import { combineReducers, createSlice, type PayloadAction } from '@reduxjs/toolkit'

import { authSlice } from '@/modules/auth/store/auth-slice'
import { notificationsSlice } from '@/modules/notifications/store/notifications-slice'
import { directorySlice } from '@/modules/accounts/store'
import { assetsSlice } from '@/modules/projects/assets/store'
import { designsSlice } from '@/modules/projects/designs/store'
import { projectsSlice } from '@/modules/projects/store'
import { reviewsSlice } from '@/modules/projects/review/store'

import { sharedHydrated } from './shared-actions'

/** Tracks which stored revision this tab has applied; used to ignore duplicate or stale sync events. */
export const syncSlice = createSlice({
  name: 'sync',
  initialState: { revision: 0 },
  reducers: {
    revisionCommitted(state, action: PayloadAction<number>) {
      state.revision = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(sharedHydrated, (state, action) => {
      state.revision = action.payload.revision
    })
  },
})

export const { revisionCommitted } = syncSlice.actions

export const rootReducer = combineReducers({
  auth: authSlice.reducer,
  sync: syncSlice.reducer,
  directory: directorySlice.reducer,
  projects: projectsSlice.reducer,
  assets: assetsSlice.reducer,
  designs: designsSlice.reducer,
  reviews: reviewsSlice.reducer,
  notifications: notificationsSlice.reducer,
})

export type RootState = ReturnType<typeof rootReducer>
